import cn from 'classnames'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

const DurationOption = ({ selected, value, handleChangeDuration }) => {
  const { t } = useTranslation()

  return (
    <div
      className={cn(styles.option, { [styles['option__selected']]: selected === value })}
      onClick={() => handleChangeDuration(value)}
    >
      {value !== 'unlimited' 
        ? <>{value} {t('days')}</>
        : t('unlimited')
      }
    </div>
  )
}

export default DurationOption
